import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { BlackList, Domains, DomainInformation, IdentitiesList } from 'pages/emails';

export const EmailRouter = ({ match }) => {
    const { path } = match;
    return (
        <Switch>
            <Route exact path={`${path}/blacklist`} render={() => <BlackList />} />
            <Route
                exact
                path={`${path}/domains`}
                render={basenameProps => {
                    const { organizationId } = basenameProps.match.params;
                    return <Domains organizationId={organizationId} />;
                }}
            />
            <Route
                exact
                path={`${path}/domains/:domainName`}
                render={basenameProps => {
                    const { domainName } = basenameProps.match.params;
                    return <DomainInformation domainName={domainName} />;
                }}
            />
            <Route
                exact
                path={`${path}/identities`}
                render={basenameProps => {
                    const { organizationId } = basenameProps.match.params;
                    return <IdentitiesList organizationId={organizationId} />;
                }}
            />
        </Switch>
    );
};
